import { render, staticRenderFns } from "./makeDialog.vue?vue&type=template&id=23bafa22&scoped=true&"
import script from "./makeDialog.vue?vue&type=script&lang=js&"
export * from "./makeDialog.vue?vue&type=script&lang=js&"
import style0 from "./makeDialog.vue?vue&type=style&index=0&id=23bafa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bafa22",
  null
  
)

export default component.exports